// Shared sortable table-header button. Generic over the column-key type so the
// bookings table (SortKey) and the owners table (OwnerSortKey) use ONE component
// — no per-table duplication. Presentational: it reflects the active key/dir and
// reports a click; the page owns the sort state and the server query.
export interface SortHeadProps<K extends string> {
  k: K;
  label: string;
  sortKey: K;
  dir: 'asc' | 'desc';
  onSort: (k: K) => void;
  // Extra class for column-specific alignment (e.g. right-aligned numerics).
  className?: string;
}

export function SortHead<K extends string>({
  k,
  label,
  sortKey,
  dir,
  onSort,
  className,
}: SortHeadProps<K>) {
  const active = sortKey === k;
  return (
    <button
      className={'bt-head-btn' + (active ? ' active' : '') + (className ? ' ' + className : '')}
      onClick={() => onSort(k)}
      title={`Sort by ${label.toLowerCase()}`}
      aria-sort={active ? (dir === 'asc' ? 'ascending' : 'descending') : 'none'}
    >
      <span>{label}</span>
      <span className={'bt-sort-arrow' + (active ? '' : ' is-hidden')}>{dir === 'asc' ? '↑' : '↓'}</span>
    </button>
  );
}
